// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   SDP — Functional colour tokens (theme-adaptive)
   Dark defaults; light overrides below.
   ═══════════════════════════════════════════════════════════ */
:root {
  /* Green / OK */
  --sdp-ok:       #6ee7b7;
  --sdp-ok-bg:    rgba(16,185,129,.09);
  --sdp-ok-bd:    rgba(16,185,129,.32);
  --sdp-ok-muted: rgba(16,185,129,.15);
  /* Amber / Warning */
  --sdp-warn:       #fcd34d;
  --sdp-warn-bg:    rgba(245,158,11,.10);
  --sdp-warn-bd:    rgba(245,158,11,.35);
  --sdp-warn-muted: rgba(245,158,11,.15);
  /* Red / Failed */
  --sdp-fail:       #fca5a5;
  --sdp-fail-bg:    rgba(239,68,68,.10);
  --sdp-fail-bd:    rgba(239,68,68,.35);
  --sdp-fail-muted: rgba(239,68,68,.15);
  --sdp-fail-text:  #f87171;
  /* Indigo / Accent chip */
  --sdp-indigo:     #a5b4fc;
  --sdp-indigo-bg:  rgba(var(--accent-rgb), .18);
  --sdp-indigo-bd:  rgba(var(--accent-rgb), .25);
  /* Sky */
  --sdp-sky:        #7dd3fc;
  --sdp-sky-bg:     rgba(14,165,233,.15);
  --sdp-sky-bd:     rgba(14,165,233,.20);
  /* Cyan / Info */
  --sdp-info:       #67e8f9;
  --sdp-info-bg:    rgba(6,182,212,.08);
  --sdp-info-bd:    rgba(6,182,212,.18);
  /* Advisory banner */
  --sdp-advisory-bg:  linear-gradient(135deg, rgba(245,158,11,.12), rgba(120,53,15,.08));
  --sdp-advisory-bd:  rgba(245,158,11,.35);
  --sdp-advisory-fg:  var(--text-primary);
  --sdp-advisory-label: #fbbf24;
  --sdp-advisory-body:  var(--text-secondary);
  /* CopyToServer modal */
  --sdp-copy-bg:     var(--bg-card);
  --sdp-copy-fg:     var(--text-primary);
  --sdp-copy-muted:  var(--text-muted);
  --sdp-copy-row-hover: var(--bg-toolbar);
  --sdp-copy-row-sel-bg: rgba(var(--accent-rgb), .12);
  --sdp-copy-row-sel-fg: var(--sdp-indigo);
  --sdp-copy-confirm:     #059669;
  --sdp-copy-confirm-dis: rgba(16,185,129,.4);
  --sdp-copy-success:     #16a34a;
}

/* ── Light-theme overrides ── */
[data-theme="light"],
[data-theme="light-sky"],
[data-theme="light-teal"],
[data-theme="light-rose"],
[data-theme="light-amber"],
[data-theme="light-emerald"] {
  --sdp-ok:       #059669;
  --sdp-ok-bg:    rgba(16,185,129,.08);
  --sdp-ok-bd:    rgba(16,185,129,.25);
  --sdp-ok-muted: rgba(16,185,129,.12);
  --sdp-warn:       #d97706;
  --sdp-warn-bg:    rgba(245,158,11,.08);
  --sdp-warn-bd:    rgba(245,158,11,.25);
  --sdp-warn-muted: rgba(245,158,11,.12);
  --sdp-fail:       #dc2626;
  --sdp-fail-bg:    rgba(239,68,68,.06);
  --sdp-fail-bd:    rgba(239,68,68,.25);
  --sdp-fail-muted: rgba(239,68,68,.12);
  --sdp-fail-text:  #dc2626;
  --sdp-indigo:     #4f46e5;
  --sdp-indigo-bg:  rgba(var(--accent-rgb), .10);
  --sdp-indigo-bd:  rgba(var(--accent-rgb), .20);
  --sdp-sky:        #0284c7;
  --sdp-sky-bg:     rgba(14,165,233,.08);
  --sdp-sky-bd:     rgba(14,165,233,.15);
  --sdp-info:       #0891b2;
  --sdp-info-bg:    rgba(6,182,212,.06);
  --sdp-info-bd:    rgba(6,182,212,.15);
  --sdp-advisory-bg:  linear-gradient(135deg, rgba(245,158,11,.10), rgba(245,158,11,.04));
  --sdp-advisory-bd:  rgba(245,158,11,.30);
  --sdp-advisory-label: #b45309;
  --sdp-copy-row-sel-bg: rgba(var(--accent-rgb), .08);
  --sdp-copy-row-sel-fg: #4f46e5;
  --sdp-copy-success:    #15803d;
}

.sdp-storage-section {
  margin-bottom: 1rem;
}

.sdp-section-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.sdp-section-toolbar-tight {
  margin-bottom: 0.75rem;
}

.sdp-section-title-inline {
  margin: 0;
}

.sdp-section-subtitle,
.sdp-slot-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.sdp-slot-summary-divider {
  color: var(--text-muted);
}

.sdp-slot-summary-occupied {
  color: var(--sdp-ok);
  font-weight: 600;
}

.sdp-slot-summary-free {
  color: var(--text-muted);
}

.sdp-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.sdp-slot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(58px, 1fr));
  gap: 0.55rem;
}

.sdp-slot-tile {
  min-height: 58px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  padding: 0.45rem 0.25rem;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.sdp-slot-tile.is-clickable {
  cursor: pointer;
}

.sdp-slot-tile.is-clickable:hover {
  transform: translateY(-1px);
}

.sdp-slot-tile-label {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.sdp-slot-tile-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: currentColor;
}

.sdp-slot-tile-capacity {
  font-size: 0.58rem;
  line-height: 1;
  opacity: 0.8;
}

.sdp-slot-tile-empty {
  color: var(--text-muted);
  border-color: var(--border);
  background: var(--bg-input);
}

.sdp-slot-tile-ok {
  color: var(--sdp-ok);
  border-color: var(--sdp-ok-bd);
  background: var(--sdp-ok-bg);
}

.sdp-slot-tile-warning {
  color: var(--sdp-warn);
  border-color: var(--sdp-warn-bd);
  background: var(--sdp-warn-bg);
}

.sdp-slot-tile-failed {
  color: var(--sdp-fail);
  border-color: var(--sdp-fail-bd);
  background: var(--sdp-fail-bg);
}

.sdp-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.9rem;
}

.sdp-empty-state {
  padding: 2.2rem 1rem;
  border: 1px dashed var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-toolbar);
  text-align: center;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.sdp-empty-state-compact {
  padding: 1.2rem 1rem;
}

.sdp-empty-state-icon {
  width: 36px;
  height: 36px;
  display: block;
  margin: 0 auto 0.75rem;
  opacity: 0.3;
}

.sdp-field-empty-hint {
  color: var(--text-muted);
  font-size: 0.78rem;
  font-style: italic;
  padding: 0.25rem 0;
}

.sdp-selector-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.25rem 0;
}

.sdp-selector-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0.2rem 0.5rem;
  font-size: 0.78rem;
  color: var(--text-secondary);
  -webkit-user-select: none;
          user-select: none;
}

.sdp-selector-chip.is-selected {
  background: var(--sdp-indigo-bg);
  border-color: var(--sdp-indigo-bd);
  color: var(--sdp-indigo);
}

.sdp-selector-chip.is-busy {
  cursor: not-allowed;
  opacity: 0.55;
  text-decoration: line-through;
  color: var(--text-muted);
}

.sdp-selector-chip-spare.is-selected {
  background: var(--sdp-warn-bg);
  border-color: var(--sdp-warn-bd);
  color: var(--sdp-warn);
}

.sdp-selector-checkbox {
  margin: 0;
  accent-color: var(--accent);
}

.sdp-array-editor {
  margin-bottom: 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 0.75rem;
  background: var(--bg-toolbar);
}

.sdp-array-editor.has-errors {
  border-color: var(--sdp-fail-bd);
}

.sdp-array-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.sdp-array-editor-hint {
  flex: 1 1;
  padding-right: 1rem;
  font-size: 0.72rem;
  color: var(--text-secondary);
  font-style: italic;
}

.sdp-array-editor-hint strong {
  color: var(--text-primary);
}

.sdp-compact-danger-btn {
  padding: 0.2rem 0.4rem;
  flex-shrink: 0;
}

.sdp-array-errors {
  background: var(--sdp-fail-bg);
  border: 1px solid var(--sdp-fail-bd);
  border-radius: var(--radius-sm);
  padding: 0.4rem 0.75rem;
  margin-bottom: 0.6rem;
  font-size: 0.78rem;
  color: var(--sdp-fail-text);
}

.sdp-array-calc-hint {
  margin-top: 0.3rem;
  font-size: 0.75rem;
  color: var(--sdp-ok);
  font-family: var(--font-mono);
}

.sdp-auto-label {
  color: var(--text-muted);
  font-weight: 400;
  font-size: 0.7rem;
}

.sdp-auto-input {
  background: var(--sdp-ok-bg) !important;
  border-color: var(--sdp-ok-bd) !important;
}

.sdp-disk-card,
.sdp-raid-card {
  position: relative;
  min-height: 176px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  box-shadow: var(--shadow-sm);
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.sdp-disk-card.is-hovered,
.sdp-raid-card:hover {
  border-color: rgba(var(--accent-rgb), .4);
  box-shadow: 0 8px 22px rgba(0,0,0,.32);
  transform: translateY(-1px);
}

.sdp-disk-card.is-retired {
  opacity: 0.7;
  background: rgba(255,255,255,.02);
}

.sdp-card-topline,
.sdp-raid-card-topline,
.sdp-raid-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.sdp-card-slot {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.45rem;
  border-radius: var(--radius-sm);
  background: var(--bg-input);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.sdp-card-type,
.sdp-raid-card-meta,
.sdp-card-temp,
.sdp-raid-card-members,
.sdp-section-subtitle {
  color: var(--text-secondary);
}

.sdp-card-type,
.sdp-raid-card-members {
  font-size: 0.72rem;
}

.sdp-card-capacity,
.sdp-raid-card-capacity {
  font-size: 1.45rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.1;
}

.sdp-card-capacity {
  text-align: center;
  margin: 0.15rem 0;
}

.sdp-card-model {
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdp-card-placeholder {
  color: var(--text-muted);
}

.sdp-card-chip-row,
.sdp-card-health-row,
.sdp-inline-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.sdp-card-chip-row,
.sdp-card-health-row {
  justify-content: center;
}

.sdp-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.4rem;
  border-radius: var(--radius-sm);
  font-size: 0.65rem;
  font-weight: 600;
  border: 1px solid transparent;
}

.sdp-chip-muted {
  background: var(--bg-input);
  border-color: var(--border);
  color: var(--text-secondary);
}

.sdp-chip-indigo {
  background: var(--sdp-indigo-bg);
  border-color: var(--sdp-indigo-bd);
  color: var(--sdp-indigo);
}

.sdp-chip-amber {
  background: var(--sdp-warn-muted);
  border-color: var(--sdp-warn-bd);
  color: var(--sdp-warn);
}

.sdp-chip-sky {
  background: var(--sdp-sky-bg);
  border-color: var(--sdp-sky-bd);
  color: var(--sdp-sky);
}

.sdp-chip-green {
  background: var(--sdp-ok-muted);
  border-color: var(--sdp-ok-bd);
  color: var(--sdp-ok);
}

.sdp-smart {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.68rem;
  font-weight: 700;
}

.sdp-smart-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: currentColor;
}

.sdp-smart-ok {
  color: var(--sdp-ok);
}

.sdp-smart-warning {
  color: var(--sdp-warn);
}

.sdp-smart-failed {
  color: var(--sdp-fail);
}

.sdp-smart-neutral {
  color: var(--text-muted);
}

.sdp-card-serial {
  margin-top: auto;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.62rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdp-card-actions {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  display: flex;
  gap: 0.25rem;
}

.sdp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: transform 0.15s ease, filter 0.15s ease;
}

.sdp-icon-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.sdp-icon-btn svg {
  width: 13px;
  height: 13px;
}

.sdp-icon-btn-indigo,
.sdp-icon-btn-violet {
  background: var(--sdp-indigo-bg);
  color: var(--sdp-indigo);
}

.sdp-icon-btn-green {
  background: var(--sdp-ok-muted);
  color: var(--sdp-ok);
}

.sdp-icon-btn-amber {
  background: var(--sdp-warn-muted);
  color: var(--sdp-warn);
}

.sdp-icon-btn-red {
  background: var(--sdp-fail-muted);
  color: var(--sdp-fail-text);
}

.sdp-raid-card {
  min-height: 170px;
}

.sdp-raid-card-controller {
  color: var(--text-primary);
  font-size: 0.74rem;
}

.sdp-raid-card-members {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sdp-raid-card-spare {
  display: inline-flex;
  align-self: flex-start;
  padding: 0.15rem 0.45rem;
  border-radius: var(--radius-sm);
  background: var(--sdp-warn-bg);
  color: var(--sdp-warn);
  font-size: 0.72rem;
}

.sdp-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: var(--modal-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.sdp-modal-shell {
  width: min(96vw, 980px);
  max-height: 90vh;
  overflow-y: auto;
  border-radius: var(--radius-xl);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  padding: 1.25rem;
}

.sdp-modal-shell-disk {
  width: min(95vw, 680px);
  padding: 1.5rem 1.75rem;
}

.sdp-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.sdp-modal-header-compact {
  margin-bottom: 0.8rem;
}

.sdp-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sdp-modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.sdp-modal-title-icon {
  width: 20px;
  height: 20px;
}

.sdp-modal-title-icon-violet {
  color: var(--accent-l);
}

.sdp-modal-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}

.sdp-modal-close-btn:hover {
  background: var(--bg-toolbar);
  color: var(--text-primary);
}

.sdp-modal-close-btn svg {
  width: 18px;
  height: 18px;
}

.sdp-section-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--accent-l);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.5rem;
}

.sdp-form-label {
  font-size: 0.78rem;
}

.sdp-toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.sdp-toggle-btn {
  padding: 0.25rem 0.75rem;
  border-radius: 5px;
  border: 1px solid var(--border);
  background: var(--bg-input);
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
}

.sdp-toggle-btn.active {
  border-color: var(--sdp-indigo-bd);
  background: var(--sdp-indigo-bg);
  color: var(--sdp-indigo);
}

.sdp-health-panel {
  background: var(--sdp-info-bg);
  border: 1px solid var(--sdp-info-bd);
  border-radius: var(--radius-lg);
  padding: 0.75rem 1rem;
  margin-bottom: 1.25rem;
}

.sdp-health-title {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--sdp-info);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.6rem;
}

.sdp-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* ── Storage advisory banner ── */
.sdp-advisory {
  position: relative;
  margin: 0 1.5rem 1rem;
  padding: 0.9rem 1rem;
  border-radius: var(--radius-xl);
  border: 1px solid var(--sdp-advisory-bd);
  background: var(--sdp-advisory-bg);
  color: var(--sdp-advisory-fg);
}

/* Ocultar el aviso sin salir del inventario (no se persiste). */
.sdp-advisory-dismiss {
  position: absolute;
  top: 8px;
  right: 10px;
  border: 1px solid var(--sdp-advisory-bd);
  background: transparent;
  color: var(--sdp-advisory-label);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}

.sdp-advisory-dismiss:hover { background: rgba(245, 158, 11, 0.16); }

.sdp-advisory-label {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sdp-advisory-label);
  font-weight: 700;
  margin-bottom: 4px;
}

.sdp-advisory-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.sdp-advisory-body {
  color: var(--sdp-advisory-body);
  line-height: 1.5;
}

.sdp-advisory-steps {
  margin-top: 8px;
  color: var(--text-muted);
  font-size: 0.9rem;
}

/* ── CopyToServer modal ── */
.sdp-copy-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: var(--modal-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sdp-copy-shell {
  background: var(--sdp-copy-bg);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  width: 480px;
  max-width: 95vw;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  padding: 1.5rem 1.75rem;
}

.sdp-copy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.1rem;
}

.sdp-copy-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sdp-copy-header-icon {
  width: 20px;
  height: 20px;
  color: var(--sdp-copy-confirm);
}

.sdp-copy-header-title {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
  font-weight: 700;
}

.sdp-copy-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: var(--text-muted);
  display: inline-flex;
  align-items: center;
}

.sdp-copy-close-btn:hover {
  color: var(--text-primary);
}

.sdp-copy-close-btn svg {
  width: 18px;
  height: 18px;
}

.sdp-copy-disk-summary {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 0.6rem 0.9rem;
  margin-bottom: 1rem;
  font-size: 0.82rem;
  color: var(--text-primary);
}

.sdp-copy-disk-summary-hint {
  color: var(--text-muted);
  font-size: 0.75rem;
  margin-top: 2px;
}

.sdp-copy-success-wrap {
  text-align: center;
  padding: 1.5rem 0;
}

.sdp-copy-success-icon {
  width: 36px;
  height: 36px;
  color: var(--sdp-copy-success);
  margin: 0 auto 0.5rem;
  display: block;
}

.sdp-copy-success-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--sdp-copy-success);
}

.sdp-copy-success-sub {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin-top: 4px;
}

.sdp-copy-close-success {
  margin-top: 1rem;
  padding: 0.4rem 1.2rem;
  background: var(--sdp-copy-success);
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}

.sdp-copy-server-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.sdp-copy-server-row {
  padding: 0.55rem 0.85rem;
  cursor: pointer;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.12s ease;
}

.sdp-copy-server-row:last-child {
  border-bottom: none;
}

.sdp-copy-server-row:hover {
  background: var(--sdp-copy-row-hover);
}

.sdp-copy-server-row.is-selected {
  background: var(--sdp-copy-row-sel-bg);
  color: var(--sdp-copy-row-sel-fg);
  font-weight: 600;
}

.sdp-copy-server-hostname {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.sdp-copy-empty,
.sdp-copy-loading {
  text-align: center;
  padding: 1.5rem;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.sdp-copy-error {
  margin-top: 0.65rem;
  font-size: 0.82rem;
  color: var(--sdp-fail-text);
  background: var(--sdp-fail-bg);
  border-radius: var(--radius-md);
  padding: 0.5rem 0.75rem;
}

.sdp-copy-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 1rem;
}

.sdp-copy-cancel-btn {
  padding: 0.35rem 0.9rem;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  font-weight: 500;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.sdp-copy-cancel-btn:hover {
  background: var(--bg-input);
  color: var(--text-primary);
}

.sdp-copy-confirm-btn {
  padding: 0.35rem 1rem;
  background: var(--sdp-copy-confirm);
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}

.sdp-copy-confirm-btn:disabled {
  background: var(--sdp-copy-confirm-dis);
  cursor: default;
}

.sdp-copy-confirm-btn.is-saving {
  opacity: 0.7;
}

@media (max-width: 768px) {
  .sdp-section-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .sdp-toolbar-actions {
    width: 100%;
  }

  .sdp-toolbar-actions .dv-btn {
    justify-content: center;
  }

  .sdp-card-grid {
    grid-template-columns: 1fr;
  }

  .sdp-slot-grid {
    grid-template-columns: repeat(auto-fit, minmax(54px, 1fr));
  }
}
/* ── Variante «tarjetas» (ficha nueva) ───────────────────────────────────
   El panel se monta con la misma estructura que la ficha: .sf2-main (sin
   scroll propio) > .sf2-headarea (cabecera + pestañas) + .sf2-scroll.
   Aquí solo falta dar aspecto de tarjeta a las secciones. */
.sf2-diskpanel .dv-tab-pane > .dv-section {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 10px);
  padding: 16px;
}

.sf2-diskpanel .dv-tab-pane > .dv-section + .dv-section { margin-top: 16px; }
.sf2-diskpanel .dv-tab-pane { padding-top: 1.25rem; }
`, "",{"version":3,"sources":["webpack://./src/styles/ServerDisksPanel.css"],"names":[],"mappings":"AAAA;;;gEAGgE;AAChE;EACE,eAAe;EACf,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oBAAoB;EACpB,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;EAC9C,8CAA8C;EAC9C,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,oBAAoB;EACpB,sFAAsF;EACtF,wCAAwC;EACxC,uCAAuC;EACvC,6BAA6B;EAC7B,2CAA2C;EAC3C,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,oCAAoC;EACpC,uCAAuC;EACvC,mDAAmD;EACnD,wCAAwC;EACxC,+BAA+B;EAC/B,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;;;;;;EAME,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;EAC9C,8CAA8C;EAC9C,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;EACtC,yBAAyB;EACzB,qCAAqC;EACrC,qCAAqC;EACrC,uFAAuF;EACvF,wCAAwC;EACxC,6BAA6B;EAC7B,mDAAmD;EACnD,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,gFAAgF;AAClF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gFAAgF;AAClF;;AAEA;;EAEE,yCAAyC;EACzC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;EAC/B,wCAAwC;EACxC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,oCAAoC,EAAE;;AAEpE;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0DAA0D;EAC5D;AACF;AACA;;;4DAG4D;AAC5D;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;AACf;;AAEA,0DAA0D,gBAAgB,EAAE;AAC5E,8BAA8B,oBAAoB,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════════════\r\n   SDP — Functional colour tokens (theme-adaptive)\r\n   Dark defaults; light overrides below.\r\n   ═══════════════════════════════════════════════════════════ */\r\n:root {\r\n  /* Green / OK */\r\n  --sdp-ok:       #6ee7b7;\r\n  --sdp-ok-bg:    rgba(16,185,129,.09);\r\n  --sdp-ok-bd:    rgba(16,185,129,.32);\r\n  --sdp-ok-muted: rgba(16,185,129,.15);\r\n  /* Amber / Warning */\r\n  --sdp-warn:       #fcd34d;\r\n  --sdp-warn-bg:    rgba(245,158,11,.10);\r\n  --sdp-warn-bd:    rgba(245,158,11,.35);\r\n  --sdp-warn-muted: rgba(245,158,11,.15);\r\n  /* Red / Failed */\r\n  --sdp-fail:       #fca5a5;\r\n  --sdp-fail-bg:    rgba(239,68,68,.10);\r\n  --sdp-fail-bd:    rgba(239,68,68,.35);\r\n  --sdp-fail-muted: rgba(239,68,68,.15);\r\n  --sdp-fail-text:  #f87171;\r\n  /* Indigo / Accent chip */\r\n  --sdp-indigo:     #a5b4fc;\r\n  --sdp-indigo-bg:  rgba(var(--accent-rgb), .18);\r\n  --sdp-indigo-bd:  rgba(var(--accent-rgb), .25);\r\n  /* Sky */\r\n  --sdp-sky:        #7dd3fc;\r\n  --sdp-sky-bg:     rgba(14,165,233,.15);\r\n  --sdp-sky-bd:     rgba(14,165,233,.20);\r\n  /* Cyan / Info */\r\n  --sdp-info:       #67e8f9;\r\n  --sdp-info-bg:    rgba(6,182,212,.08);\r\n  --sdp-info-bd:    rgba(6,182,212,.18);\r\n  /* Advisory banner */\r\n  --sdp-advisory-bg:  linear-gradient(135deg, rgba(245,158,11,.12), rgba(120,53,15,.08));\r\n  --sdp-advisory-bd:  rgba(245,158,11,.35);\r\n  --sdp-advisory-fg:  var(--text-primary);\r\n  --sdp-advisory-label: #fbbf24;\r\n  --sdp-advisory-body:  var(--text-secondary);\r\n  /* CopyToServer modal */\r\n  --sdp-copy-bg:     var(--bg-card);\r\n  --sdp-copy-fg:     var(--text-primary);\r\n  --sdp-copy-muted:  var(--text-muted);\r\n  --sdp-copy-row-hover: var(--bg-toolbar);\r\n  --sdp-copy-row-sel-bg: rgba(var(--accent-rgb), .12);\r\n  --sdp-copy-row-sel-fg: var(--sdp-indigo);\r\n  --sdp-copy-confirm:     #059669;\r\n  --sdp-copy-confirm-dis: rgba(16,185,129,.4);\r\n  --sdp-copy-success:     #16a34a;\r\n}\r\n\r\n/* ── Light-theme overrides ── */\r\n[data-theme=\"light\"],\r\n[data-theme=\"light-sky\"],\r\n[data-theme=\"light-teal\"],\r\n[data-theme=\"light-rose\"],\r\n[data-theme=\"light-amber\"],\r\n[data-theme=\"light-emerald\"] {\r\n  --sdp-ok:       #059669;\r\n  --sdp-ok-bg:    rgba(16,185,129,.08);\r\n  --sdp-ok-bd:    rgba(16,185,129,.25);\r\n  --sdp-ok-muted: rgba(16,185,129,.12);\r\n  --sdp-warn:       #d97706;\r\n  --sdp-warn-bg:    rgba(245,158,11,.08);\r\n  --sdp-warn-bd:    rgba(245,158,11,.25);\r\n  --sdp-warn-muted: rgba(245,158,11,.12);\r\n  --sdp-fail:       #dc2626;\r\n  --sdp-fail-bg:    rgba(239,68,68,.06);\r\n  --sdp-fail-bd:    rgba(239,68,68,.25);\r\n  --sdp-fail-muted: rgba(239,68,68,.12);\r\n  --sdp-fail-text:  #dc2626;\r\n  --sdp-indigo:     #4f46e5;\r\n  --sdp-indigo-bg:  rgba(var(--accent-rgb), .10);\r\n  --sdp-indigo-bd:  rgba(var(--accent-rgb), .20);\r\n  --sdp-sky:        #0284c7;\r\n  --sdp-sky-bg:     rgba(14,165,233,.08);\r\n  --sdp-sky-bd:     rgba(14,165,233,.15);\r\n  --sdp-info:       #0891b2;\r\n  --sdp-info-bg:    rgba(6,182,212,.06);\r\n  --sdp-info-bd:    rgba(6,182,212,.15);\r\n  --sdp-advisory-bg:  linear-gradient(135deg, rgba(245,158,11,.10), rgba(245,158,11,.04));\r\n  --sdp-advisory-bd:  rgba(245,158,11,.30);\r\n  --sdp-advisory-label: #b45309;\r\n  --sdp-copy-row-sel-bg: rgba(var(--accent-rgb), .08);\r\n  --sdp-copy-row-sel-fg: #4f46e5;\r\n  --sdp-copy-success:    #15803d;\r\n}\r\n\r\n.sdp-storage-section {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.sdp-section-toolbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.sdp-section-toolbar-tight {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.sdp-section-title-inline {\r\n  margin: 0;\r\n}\r\n\r\n.sdp-section-subtitle,\r\n.sdp-slot-summary {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.35rem;\r\n  align-items: center;\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sdp-slot-summary-divider {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-slot-summary-occupied {\r\n  color: var(--sdp-ok);\r\n  font-weight: 600;\r\n}\r\n\r\n.sdp-slot-summary-free {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-toolbar-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.sdp-slot-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(58px, 1fr));\r\n  gap: 0.55rem;\r\n}\r\n\r\n.sdp-slot-tile {\r\n  min-height: 58px;\r\n  border-radius: var(--radius-md);\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.15rem;\r\n  padding: 0.45rem 0.25rem;\r\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.sdp-slot-tile.is-clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.sdp-slot-tile.is-clickable:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.sdp-slot-tile-label {\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.sdp-slot-tile-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  background: currentColor;\r\n}\r\n\r\n.sdp-slot-tile-capacity {\r\n  font-size: 0.58rem;\r\n  line-height: 1;\r\n  opacity: 0.8;\r\n}\r\n\r\n.sdp-slot-tile-empty {\r\n  color: var(--text-muted);\r\n  border-color: var(--border);\r\n  background: var(--bg-input);\r\n}\r\n\r\n.sdp-slot-tile-ok {\r\n  color: var(--sdp-ok);\r\n  border-color: var(--sdp-ok-bd);\r\n  background: var(--sdp-ok-bg);\r\n}\r\n\r\n.sdp-slot-tile-warning {\r\n  color: var(--sdp-warn);\r\n  border-color: var(--sdp-warn-bd);\r\n  background: var(--sdp-warn-bg);\r\n}\r\n\r\n.sdp-slot-tile-failed {\r\n  color: var(--sdp-fail);\r\n  border-color: var(--sdp-fail-bd);\r\n  background: var(--sdp-fail-bg);\r\n}\r\n\r\n.sdp-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 0.9rem;\r\n}\r\n\r\n.sdp-empty-state {\r\n  padding: 2.2rem 1rem;\r\n  border: 1px dashed var(--border);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--bg-toolbar);\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sdp-empty-state-compact {\r\n  padding: 1.2rem 1rem;\r\n}\r\n\r\n.sdp-empty-state-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: block;\r\n  margin: 0 auto 0.75rem;\r\n  opacity: 0.3;\r\n}\r\n\r\n.sdp-field-empty-hint {\r\n  color: var(--text-muted);\r\n  font-size: 0.78rem;\r\n  font-style: italic;\r\n  padding: 0.25rem 0;\r\n}\r\n\r\n.sdp-selector-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.35rem;\r\n  padding: 0.25rem 0;\r\n}\r\n\r\n.sdp-selector-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  cursor: pointer;\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-sm);\r\n  padding: 0.2rem 0.5rem;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n  user-select: none;\r\n}\r\n\r\n.sdp-selector-chip.is-selected {\r\n  background: var(--sdp-indigo-bg);\r\n  border-color: var(--sdp-indigo-bd);\r\n  color: var(--sdp-indigo);\r\n}\r\n\r\n.sdp-selector-chip.is-busy {\r\n  cursor: not-allowed;\r\n  opacity: 0.55;\r\n  text-decoration: line-through;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-selector-chip-spare.is-selected {\r\n  background: var(--sdp-warn-bg);\r\n  border-color: var(--sdp-warn-bd);\r\n  color: var(--sdp-warn);\r\n}\r\n\r\n.sdp-selector-checkbox {\r\n  margin: 0;\r\n  accent-color: var(--accent);\r\n}\r\n\r\n.sdp-array-editor {\r\n  margin-bottom: 0.75rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md);\r\n  padding: 0.75rem;\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.sdp-array-editor.has-errors {\r\n  border-color: var(--sdp-fail-bd);\r\n}\r\n\r\n.sdp-array-editor-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.sdp-array-editor-hint {\r\n  flex: 1;\r\n  padding-right: 1rem;\r\n  font-size: 0.72rem;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n}\r\n\r\n.sdp-array-editor-hint strong {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-compact-danger-btn {\r\n  padding: 0.2rem 0.4rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sdp-array-errors {\r\n  background: var(--sdp-fail-bg);\r\n  border: 1px solid var(--sdp-fail-bd);\r\n  border-radius: var(--radius-sm);\r\n  padding: 0.4rem 0.75rem;\r\n  margin-bottom: 0.6rem;\r\n  font-size: 0.78rem;\r\n  color: var(--sdp-fail-text);\r\n}\r\n\r\n.sdp-array-calc-hint {\r\n  margin-top: 0.3rem;\r\n  font-size: 0.75rem;\r\n  color: var(--sdp-ok);\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.sdp-auto-label {\r\n  color: var(--text-muted);\r\n  font-weight: 400;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.sdp-auto-input {\r\n  background: var(--sdp-ok-bg) !important;\r\n  border-color: var(--sdp-ok-bd) !important;\r\n}\r\n\r\n.sdp-disk-card,\r\n.sdp-raid-card {\r\n  position: relative;\r\n  min-height: 176px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  box-shadow: var(--shadow-sm);\r\n  padding: 0.8rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.45rem;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.sdp-disk-card.is-hovered,\r\n.sdp-raid-card:hover {\r\n  border-color: rgba(var(--accent-rgb), .4);\r\n  box-shadow: 0 8px 22px rgba(0,0,0,.32);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.sdp-disk-card.is-retired {\r\n  opacity: 0.7;\r\n  background: rgba(255,255,255,.02);\r\n}\r\n\r\n.sdp-card-topline,\r\n.sdp-raid-card-topline,\r\n.sdp-raid-card-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.sdp-card-slot {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.15rem 0.45rem;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-secondary);\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.sdp-card-type,\r\n.sdp-raid-card-meta,\r\n.sdp-card-temp,\r\n.sdp-raid-card-members,\r\n.sdp-section-subtitle {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sdp-card-type,\r\n.sdp-raid-card-members {\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.sdp-card-capacity,\r\n.sdp-raid-card-capacity {\r\n  font-size: 1.45rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  line-height: 1.1;\r\n}\r\n\r\n.sdp-card-capacity {\r\n  text-align: center;\r\n  margin: 0.15rem 0;\r\n}\r\n\r\n.sdp-card-model {\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-size: 0.75rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sdp-card-placeholder {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-card-chip-row,\r\n.sdp-card-health-row,\r\n.sdp-inline-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.sdp-card-chip-row,\r\n.sdp-card-health-row {\r\n  justify-content: center;\r\n}\r\n\r\n.sdp-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.15rem 0.4rem;\r\n  border-radius: var(--radius-sm);\r\n  font-size: 0.65rem;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.sdp-chip-muted {\r\n  background: var(--bg-input);\r\n  border-color: var(--border);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sdp-chip-indigo {\r\n  background: var(--sdp-indigo-bg);\r\n  border-color: var(--sdp-indigo-bd);\r\n  color: var(--sdp-indigo);\r\n}\r\n\r\n.sdp-chip-amber {\r\n  background: var(--sdp-warn-muted);\r\n  border-color: var(--sdp-warn-bd);\r\n  color: var(--sdp-warn);\r\n}\r\n\r\n.sdp-chip-sky {\r\n  background: var(--sdp-sky-bg);\r\n  border-color: var(--sdp-sky-bd);\r\n  color: var(--sdp-sky);\r\n}\r\n\r\n.sdp-chip-green {\r\n  background: var(--sdp-ok-muted);\r\n  border-color: var(--sdp-ok-bd);\r\n  color: var(--sdp-ok);\r\n}\r\n\r\n.sdp-smart {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.sdp-smart-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  background: currentColor;\r\n}\r\n\r\n.sdp-smart-ok {\r\n  color: var(--sdp-ok);\r\n}\r\n\r\n.sdp-smart-warning {\r\n  color: var(--sdp-warn);\r\n}\r\n\r\n.sdp-smart-failed {\r\n  color: var(--sdp-fail);\r\n}\r\n\r\n.sdp-smart-neutral {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-card-serial {\r\n  margin-top: auto;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.62rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sdp-card-actions {\r\n  position: absolute;\r\n  top: 0.4rem;\r\n  right: 0.4rem;\r\n  display: flex;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.sdp-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--radius-sm);\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n}\r\n\r\n.sdp-icon-btn:hover {\r\n  transform: translateY(-1px);\r\n  filter: brightness(1.05);\r\n}\r\n\r\n.sdp-icon-btn svg {\r\n  width: 13px;\r\n  height: 13px;\r\n}\r\n\r\n.sdp-icon-btn-indigo,\r\n.sdp-icon-btn-violet {\r\n  background: var(--sdp-indigo-bg);\r\n  color: var(--sdp-indigo);\r\n}\r\n\r\n.sdp-icon-btn-green {\r\n  background: var(--sdp-ok-muted);\r\n  color: var(--sdp-ok);\r\n}\r\n\r\n.sdp-icon-btn-amber {\r\n  background: var(--sdp-warn-muted);\r\n  color: var(--sdp-warn);\r\n}\r\n\r\n.sdp-icon-btn-red {\r\n  background: var(--sdp-fail-muted);\r\n  color: var(--sdp-fail-text);\r\n}\r\n\r\n.sdp-raid-card {\r\n  min-height: 170px;\r\n}\r\n\r\n.sdp-raid-card-controller {\r\n  color: var(--text-primary);\r\n  font-size: 0.74rem;\r\n}\r\n\r\n.sdp-raid-card-members {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sdp-raid-card-spare {\r\n  display: inline-flex;\r\n  align-self: flex-start;\r\n  padding: 0.15rem 0.45rem;\r\n  border-radius: var(--radius-sm);\r\n  background: var(--sdp-warn-bg);\r\n  color: var(--sdp-warn);\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.sdp-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2000;\r\n  background: var(--modal-overlay);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n}\r\n\r\n.sdp-modal-shell {\r\n  width: min(96vw, 980px);\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  border-radius: var(--radius-xl);\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  box-shadow: var(--shadow-lg);\r\n  padding: 1.25rem;\r\n}\r\n\r\n.sdp-modal-shell-disk {\r\n  width: min(95vw, 680px);\r\n  padding: 1.5rem 1.75rem;\r\n}\r\n\r\n.sdp-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.sdp-modal-header-compact {\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.sdp-modal-title-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.sdp-modal-title {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-modal-title-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.sdp-modal-title-icon-violet {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.sdp-modal-close-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border: none;\r\n  border-radius: var(--radius-sm);\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.sdp-modal-close-btn:hover {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-modal-close-btn svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.sdp-section-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: var(--accent-l);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.sdp-form-label {\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.sdp-toggle-group {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.sdp-toggle-btn {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 5px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input);\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.sdp-toggle-btn.active {\r\n  border-color: var(--sdp-indigo-bd);\r\n  background: var(--sdp-indigo-bg);\r\n  color: var(--sdp-indigo);\r\n}\r\n\r\n.sdp-health-panel {\r\n  background: var(--sdp-info-bg);\r\n  border: 1px solid var(--sdp-info-bd);\r\n  border-radius: var(--radius-lg);\r\n  padding: 0.75rem 1rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.sdp-health-title {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: var(--sdp-info);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  margin-bottom: 0.6rem;\r\n}\r\n\r\n.sdp-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n\r\n/* ── Storage advisory banner ── */\r\n.sdp-advisory {\r\n  position: relative;\r\n  margin: 0 1.5rem 1rem;\r\n  padding: 0.9rem 1rem;\r\n  border-radius: var(--radius-xl);\r\n  border: 1px solid var(--sdp-advisory-bd);\r\n  background: var(--sdp-advisory-bg);\r\n  color: var(--sdp-advisory-fg);\r\n}\r\n\r\n/* Ocultar el aviso sin salir del inventario (no se persiste). */\r\n.sdp-advisory-dismiss {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 10px;\r\n  border: 1px solid var(--sdp-advisory-bd);\r\n  background: transparent;\r\n  color: var(--sdp-advisory-label);\r\n  border-radius: 999px;\r\n  padding: 2px 10px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.sdp-advisory-dismiss:hover { background: rgba(245, 158, 11, 0.16); }\r\n\r\n.sdp-advisory-label {\r\n  font-size: 0.75rem;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--sdp-advisory-label);\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sdp-advisory-title {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sdp-advisory-body {\r\n  color: var(--sdp-advisory-body);\r\n  line-height: 1.5;\r\n}\r\n\r\n.sdp-advisory-steps {\r\n  margin-top: 8px;\r\n  color: var(--text-muted);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* ── CopyToServer modal ── */\r\n.sdp-copy-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 3000;\r\n  background: var(--modal-overlay);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sdp-copy-shell {\r\n  background: var(--sdp-copy-bg);\r\n  border-radius: var(--radius-xl);\r\n  border: 1px solid var(--border);\r\n  width: 480px;\r\n  max-width: 95vw;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: var(--shadow-lg);\r\n  padding: 1.5rem 1.75rem;\r\n}\r\n\r\n.sdp-copy-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1.1rem;\r\n}\r\n\r\n.sdp-copy-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.sdp-copy-header-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: var(--sdp-copy-confirm);\r\n}\r\n\r\n.sdp-copy-header-title {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.sdp-copy-close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  color: var(--text-muted);\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.sdp-copy-close-btn:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-copy-close-btn svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.sdp-copy-disk-summary {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  padding: 0.6rem 0.9rem;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.82rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-copy-disk-summary-hint {\r\n  color: var(--text-muted);\r\n  font-size: 0.75rem;\r\n  margin-top: 2px;\r\n}\r\n\r\n.sdp-copy-success-wrap {\r\n  text-align: center;\r\n  padding: 1.5rem 0;\r\n}\r\n\r\n.sdp-copy-success-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  color: var(--sdp-copy-success);\r\n  margin: 0 auto 0.5rem;\r\n  display: block;\r\n}\r\n\r\n.sdp-copy-success-text {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--sdp-copy-success);\r\n}\r\n\r\n.sdp-copy-success-sub {\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n  margin-top: 4px;\r\n}\r\n\r\n.sdp-copy-close-success {\r\n  margin-top: 1rem;\r\n  padding: 0.4rem 1.2rem;\r\n  background: var(--sdp-copy-success);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sdp-copy-server-list {\r\n  max-height: 240px;\r\n  overflow-y: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n}\r\n\r\n.sdp-copy-server-row {\r\n  padding: 0.55rem 0.85rem;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  border-bottom: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.sdp-copy-server-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.sdp-copy-server-row:hover {\r\n  background: var(--sdp-copy-row-hover);\r\n}\r\n\r\n.sdp-copy-server-row.is-selected {\r\n  background: var(--sdp-copy-row-sel-bg);\r\n  color: var(--sdp-copy-row-sel-fg);\r\n  font-weight: 600;\r\n}\r\n\r\n.sdp-copy-server-hostname {\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sdp-copy-empty,\r\n.sdp-copy-loading {\r\n  text-align: center;\r\n  padding: 1.5rem;\r\n  color: var(--text-muted);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sdp-copy-error {\r\n  margin-top: 0.65rem;\r\n  font-size: 0.82rem;\r\n  color: var(--sdp-fail-text);\r\n  background: var(--sdp-fail-bg);\r\n  border-radius: var(--radius-md);\r\n  padding: 0.5rem 0.75rem;\r\n}\r\n\r\n.sdp-copy-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.sdp-copy-cancel-btn {\r\n  padding: 0.35rem 0.9rem;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-md);\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sdp-copy-cancel-btn:hover {\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sdp-copy-confirm-btn {\r\n  padding: 0.35rem 1rem;\r\n  background: var(--sdp-copy-confirm);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sdp-copy-confirm-btn:disabled {\r\n  background: var(--sdp-copy-confirm-dis);\r\n  cursor: default;\r\n}\r\n\r\n.sdp-copy-confirm-btn.is-saving {\r\n  opacity: 0.7;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .sdp-section-toolbar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .sdp-toolbar-actions {\r\n    width: 100%;\r\n  }\r\n\r\n  .sdp-toolbar-actions .dv-btn {\r\n    justify-content: center;\r\n  }\r\n\r\n  .sdp-card-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .sdp-slot-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(54px, 1fr));\r\n  }\r\n}\r\n/* ── Variante «tarjetas» (ficha nueva) ───────────────────────────────────\r\n   El panel se monta con la misma estructura que la ficha: .sf2-main (sin\r\n   scroll propio) > .sf2-headarea (cabecera + pestañas) + .sf2-scroll.\r\n   Aquí solo falta dar aspecto de tarjeta a las secciones. */\r\n.sf2-diskpanel .dv-tab-pane > .dv-section {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg, 10px);\r\n  padding: 16px;\r\n}\r\n\r\n.sf2-diskpanel .dv-tab-pane > .dv-section + .dv-section { margin-top: 16px; }\r\n.sf2-diskpanel .dv-tab-pane { padding-top: 1.25rem; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
